'use client';

import { useEffect, useState } from 'react';

import { useCurrentUserId } from '@ps/ui/contexts/auth';

import { subscribeToMyMessageBookmarks } from '../functions/bookmarks/subscribeToMyMessageBookmarks';

/**
 * Live set of `messageId`s the current user has bookmarked in the
 * given channel. Drives the "is-bookmarked?" highlight on each
 * bubble's kebab menu (Bookmark vs Un-bookmark label) and the
 * indicator decoration if/when the bubble adds one.
 *
 * Returns an empty Set while loading or when there's no signed-in
 * user — the kebab defaults to the "Bookmark" affirmative label in
 * that case.
 */
export function useMyMessageBookmarks(
  channelId: string | null | undefined,
): Set<string> {
  const userId = useCurrentUserId();
  const [ids, setIds] = useState<Set<string>>(() => new Set());

  useEffect(() => {
    if (!userId || !channelId) {
      setIds(new Set());
      return;
    }
    return subscribeToMyMessageBookmarks(userId, channelId, setIds);
  }, [userId, channelId]);

  return ids;
}
